module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-desktop-phone.pl-39b435e09c24f4b027f0af5b51d173af.png";